import {onClick} from '../abstract/helpers.js';

export class LocationMap {
  constructor() {
    if(document.querySelector('.location-map')) {

      document.querySelectorAll('.location-map [data-location]').forEach(function(el) {

        el.addEventListener("mouseenter", function(e) {
          if(
            document.querySelector('.location-map .location-icon[data-location="'+e.target.getAttribute('data-location')+'"]') &&
            document.querySelector('.location-map .location-name[data-location="'+e.target.getAttribute('data-location')+'"]')
            ) {
            document.querySelector('.location-map .location-icon[data-location="'+e.target.getAttribute('data-location')+'"]').classList.add('active');
            document.querySelector('.location-map .location-name[data-location="'+e.target.getAttribute('data-location')+'"]').classList.add('active');
          }
        });

        el.addEventListener("mouseleave", function(e) {

          if(
            document.querySelector('.location-map .location-icon[data-location="'+e.target.getAttribute('data-location')+'"]') &&
            document.querySelector('.location-map .location-name[data-location="'+e.target.getAttribute('data-location')+'"]')
            ) {
            document.querySelector('.location-map .location-icon[data-location="'+e.target.getAttribute('data-location')+'"]').classList.remove('active');
            document.querySelector('.location-map .location-name[data-location="'+e.target.getAttribute('data-location')+'"]').classList.remove('active');
          }
        });

      });

    }

  }
}
